










































































import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";

@Component
export default class Offerings extends Vue {
  private productOfferings = [
    {
      icon: '',
      title : 'Full stack',
      description: ''
    },
    {
      icon: '',
      title : 'Yearly License',
      description: ''
    },
    {
      icon: '',
      title : 'Unlimited development installation',
      description: ''
    },
    {
      icon: '',
      title : 'One production installation',
      description: ''
    },
    {
      icon: '',
      title : 'Quarterly upgrade',
      description: ''
    },
    {
      icon: '',
      title : 'Patch release for stability',
      description: ''
    },
    {
      icon: '',
      title : 'SLA based support',
      description: ''
    }
  ];

  private serviceOfferings = [
          {
            icon: '',
            title : 'Modeling and Implementation of processes',
            description: ''
      },
      {
            icon: '',
            title : 'Test and Deployment',
            description: ''
      },
      {
            icon: '',
            title : 'Production Monitoring',
            description: ''
      },
      {
            icon: '',
            title : 'Process changes and Implementation',
            description: ''
      },
      {
            icon: '',
            title : 'Provide data in format required by downstream systems',
            description: ''
      },
      {
            icon: '',
            title : 'Build custom integration API ',
            description: ''
      },
      {
            icon: '',
            title : 'Guide the technical team to integrate with Prism',
            description: ''
      }

  ]
}
